module.exports = __webpack_public_path__ + "img/icons.d6ed19f7.gif";